import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import { getAudioFileUrl } from '@culture/utils/helpers/files';
import { PlaylistContainer } from 'components/Audio/PlaylistContainer';

const { publicRuntimeConfig } = getConfig();

const prepareTrackList = (podcasts) => {
	const trackList = podcasts.reduce((list, currentPodcast) => {
		const { status } = currentPodcast;
		if (status === 'published') {
			const { files, _id, title, widget } = currentPodcast;
			const file = !!files?.length && files[0];
			list.push({
				_id,
				title,
				key: _id,
				widgetId: widget?._id,
				src:
					file &&
					getAudioFileUrl(file, {
						config: publicRuntimeConfig
					})
			});
		}
		return list;
	}, []);

	return trackList;
};

const PodcastsList = ({ podcasts }) => {
	const trackList = prepareTrackList(podcasts);

	return <PlaylistContainer {...{ trackList }} />;
};

PodcastsList.propTypes = {
	podcasts: PropTypes.array
};

export default PodcastsList;
